import React from "react";
import {Icon, TabControlButton, TabControlPage} from "peggirkit";
import {TruckIcon} from "@heroicons/react/20/solid";
import {OrderEditorTabProps} from "@widgets/pos/order/OrderEditor";
import {useIntl} from "react-intl";
import FulfillmentOptions from "@widgets/pos/order/fulfillment/FulfillmentOptions";

const FulfillmentTab = (tabProps: OrderEditorTabProps) => {
    const intl = useIntl();

    return (
        <TabControlPage
            tabButton={
                <TabControlButton iconBefore={<Icon icon={TruckIcon}/>}>
                    {intl.formatMessage({id: "fulfillment"})}
                </TabControlButton>
            }
        >
            <FulfillmentOptions {...tabProps}/>
        </TabControlPage>
    );
};

export default FulfillmentTab;